export default __webpack_public_path__ + "1f1353e81e6c7fe25dce2aa34e7d2ff1.webp";